import { CommandingRunTask } from '@/backend/models/commandingRunTask';
import { useGlobalStore } from '@/frontend/store/GlobalStore';
import { SPECIAL_INSTRUMENTS, VERIFORM_METHODS } from '@/frontend/utils/customCodeMirror';
import { I18n } from '@/i18n/I18n';
import yaml from 'js-yaml';
import { Download } from '@/frontend/SVGs/Download';
import { ButtonParent } from '../buttons/ButtonParent';
import { FileWithDisplay } from '../files/FileWithDisplay';

export function CommandingRunDisplayItemWrapper(props: { task: CommandingRunTask }) {
  const { task } = props;
  const downloadFileById = useGlobalStore(state => state.downloadFileById);
  const { asset } = task;

  if (asset) {
    return (
      <div className="col">
        <FileWithDisplay file={asset} />
        <ButtonParent title={I18n.get('downloadFile', { fileName: asset.fileName })} onClick={() => void downloadFileById(asset)}><Download /></ButtonParent>
        {`${I18n.get('File')}: ${asset.fileName}`}
      </div>
    );
  }

  const parsedTaskResponse = yaml.load(task.taskResponseYaml) as any;

  if (parsedTaskResponse) {
    const [providerMethod, params] = Object.entries(parsedTaskResponse)[0];
    if (providerMethod === `${SPECIAL_INSTRUMENTS.VERIFORM}.${VERIFORM_METHODS.TEXT_OUTPUT}`) {
      return (
        <div className="col">{(params as any)?.content}</div>
      );
    }
  }

  return <span />;
}
